import { FEProduct, ProductsStore } from './products-types';

/**
 * Возвращает данные об актуальных измерениях
 * @param {ProductsStore} products
 * @param {string[]} productIdList
 * @param {string | undefined} regionCode
 * @returns {FEProduct[]}
 */
export const selectActualProductList = (
  products: ProductsStore,
  productIdList: string[],
): FEProduct[] =>
  productIdList.reduce((acc: FEProduct[], productId: string) => {
    if (!products.productList) {
      return acc;
    }

    const product = products.productList[productId];

    if (!product) {
      return acc;
    }

    return [
      ...acc,
      {
        ...product,
        productId,
      },
    ];
  }, []);
